/**
 * ParallaxBackground section
 */
(function parallaxBackgroundFrontend($) {
	$(document).on('cms.ready', ready);


	/* Initial building of the ServiceCases */
	function ready() {

		// TODO Mikkel: @see https://codepen.io/shshaw/pen/PaRJWm
		// using --scroll variable in css

		$('.sectionParallaxBackground').each(setupSection);
	}

	function setupSection(i, section) {
		let $section = $(section);

		$(window).on('scroll', function() {
			let distToTop = ($section.offset().top + $section.height()/2) - $(window).scrollTop();
			let pctInView = (distToTop * 100) / $(window).height();

			// clamp between 0..100
			pctInView = Math.max(0, pctInView);
			pctInView = Math.min(100, pctInView);


			let speed = 1;
			let movement = (100 - pctInView) * speed;

			$section.css({'--scroll': movement + '%'});

		});
	}
})(jQuery);